import { Component, effect, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Institution, InstitutionType } from '../../services/institution.service';
import { MetricService } from '../../services/metric.service';
import { VisualService } from '../../services/visual.service';

export interface KpiData {
  title: string;
  currentValue: string;
  previousValue: string;
  up: boolean;
  down: boolean;
}

@Component({
  selector: 'app-kpi-recent-institution',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './kpi-recent-institution.component.html',
  styleUrl: './kpi-recent-institution.component.scss'
})
export class KpiRecentInstitutionComponent {
  readonly institution = input<Institution>();
  readonly metricInput = input<string>("");
  readonly titleInput = input<string>("");
  readonly invertColors = input<boolean>(false);

  invertTitles: boolean = false;

  private metricService = inject(MetricService);
  readonly loading = signal<boolean>(true);
  readonly kpiData = signal<KpiData | undefined>(undefined);

  constructor() {
    effect(() => {
      const institution = this.institution();
      if (institution?.iid) {
        const metricId = this.metricInput() != "" ? this.metricInput() : (institution.institutionType == InstitutionType.bank ? 'LBPR2170' : 'ACCT_010');
        this.metricService.getMetricData(institution.iid, metricId)?.subscribe(data => {
          const current = data.length > 1 ? data[data.length - 1][1] : 0;
          const previous = data.length > 2 ? data[data.length - 2][1] : 0;
          const periodDifference = current - previous;
          let kpiData: KpiData;
          //this first if is used for the nonmaturity panel
          if (this.metricInput() != "") {
            this.invertTitles = true;
            kpiData = {
              title: this.titleInput(),
              currentValue: VisualService.getValueDisplay(VisualService.getValue(current, 'PCT2') ?? 0, 'PCT2'),
              previousValue: VisualService.getValueDisplay(VisualService.getValue(previous, 'PCT2') ?? 0, 'PCT2'),
              up: this.invertColors() ? periodDifference < 0 : periodDifference > 0,
              down: this.invertColors() ? periodDifference > 0 : periodDifference < 0
            }
          }
          else {
            kpiData = {
              title: 'Total Assets ($) (QE Balance)',
              currentValue: VisualService.getValueDisplay(VisualService.getValue(current, 'USDMM') ?? 0, 'USDMM'),
              previousValue: VisualService.getValueDisplay(VisualService.getValue(previous, 'USDMM') ?? 0, 'USDMM'),
              up: periodDifference > 0,
              down: periodDifference < 0
            }
          }
          setTimeout(() => {
            this.kpiData.set(kpiData);
            this.loading.set(false);
          });
        });
      }
    });
  }
}
